import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Card } from "react-bootstrap";

import ResetPassword from "../../components/auth/ResetPassword";
import { useDispatch, useSelector } from "react-redux";
import { fetchWhitelabel } from "../../redux/slices/whitelabel";
import { useWhitelabel } from "../../contexts/WhitelabelContext";

const ResetPasswordPage = () => {
  const { whitelabel } = useSelector((state) => state.whitelabel);
  const currentUrl = window.location.hostname;
  const dispatch = useDispatch();
  const { faviconUrl } = useWhitelabel();

  return (
    <React.Fragment>
      <Helmet title="Reset Password">
        <link rel="icon" href={faviconUrl} />
      </Helmet>
      <div className="text-center mt-4">
        <h1 className="h2">Reset password</h1>
        <p className="lead">Enter your email to reset your password.</p>
      </div>

      <Card>
        <Card.Body>
          <div className="m-sm-4">
            <ResetPassword />
          </div>
        </Card.Body>
      </Card>
    </React.Fragment>
  );
};

export default ResetPasswordPage;
